import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Login from '@/components/Login'
import User from '@/components/admin/user/Index'
import store from './../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      meta: { layout: "login" },
      component: Login
    },
    /* Admin */
    {
      path: '/user',
      name: 'User',
      meta: { layout: "dashboard", requiresAuth: true, isAdmin: true },
      component: User,
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    if (store.getters.loggedIn) {
      next('/')
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next('/login')
    }
  }

  if (to.matched.some(record => record.meta.isAdmin)) {
    if (!store.getters.isAdmin) {
      next('/')
    }
  }

  next()
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js